import { useState } from "react";
import { Dialog } from "../components/shared/Dialog";
import {
  Box,
  CircularProgress,
  Dialog as MuiDialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { CriteriaPage } from "./SubmitCriteria";

export const SubmitPage = (props) => {
  const [showMask, setShowMask] = useState(true);
  return (
    <>
      {showMask && (
        <Box
          sx={{
            height: "200px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      )}
      <iframe
        onLoad={() => setShowMask(false)}
        className="airtable-embed"
        src="https://airtable.com/embed/shrDxzxahvslUlPGj?backgroundColor=pink"
        width="100%"
        title="submission"
        style={{
          background: "transparent",
          height: props.height || "100%",
          border: "none",
        }}
      ></iframe>
    </>
  );
};

export const Submit = (props) => {
  const { open, toggle } = props;
  return (
    <Dialog
      open={open}
      toggle={toggle}
      label="Submit"
      title="Submit a Destination"
      content={<SubmitPage height={"80vh"} />}
      contentStyles={{ padding: 0 }}
    />
  );
};

export const SubmitWithCriteria = ({ open, toggle }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <MuiDialog
      open={open}
      onClose={toggle}
      fullWidth
      maxWidth="lg"
      fullScreen={fullScreen}
      PaperProps={{
        sx: {
          height: fullScreen ? "100%" : "85vh",
          borderRadius: fullScreen ? 0 : "16px",
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #ececec",
          py: 1.5,
          px: 2.5,
          background: "#fff",
        }}
      >
        <Typography
          sx={{ fontWeight: 700, fontSize: "17px", letterSpacing: "0.01em" }}
        >
          Submit a Destination
        </Typography>
        <IconButton aria-label="close" onClick={toggle} size="small">
          <Close fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: fullScreen ? "column" : "row",
          padding: 0,
          overflow: "hidden",
          height: "100%",
          position: "relative",
          background: "#f5f2ee",
        }}
      >
        {/* Submit form — overlaps criteria with shadow */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            minHeight: fullScreen ? "60vh" : 0,
            mr: fullScreen ? 0 : "-28px",
            boxShadow: fullScreen ? "none" : "8px 0 32px 0 rgba(0,0,0,0.14)",
            backgroundColor: "#fff",
            zIndex: 1,
          }}
        >
          <SubmitPage height="100%" />
        </Box>
        {/* Criteria — sits behind on the right */}
        <Box
          sx={{
            width: fullScreen ? "100%" : "40%",
            height: fullScreen ? "50vh" : "auto",
            overflow: "scroll",
            flexShrink: 0,
            display: "flex",
            flexDirection: "column",
            pl: fullScreen ? 0 : "32px",
            "&::-webkit-scrollbar": { width: "8px" },
            "&::-webkit-scrollbar-track": { background: "transparent" },
            "&::-webkit-scrollbar-thumb": {
              background: "#c8bdb4",
              borderRadius: "4px",
            },
          }}
        >
          <Box
            sx={{
              px: 3,
              pt: 3,
              pb: 1,
              textAlign: "center",
              borderBottom: "1px solid #ddd8d0",
            }}
          >
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "13px",
                letterSpacing: "0.12em",
                textTransform: "uppercase",
                color: "#7a6a58",
              }}
            >
              Submission Criteria
            </Typography>
          </Box>
          <CriteriaPage />
        </Box>
      </DialogContent>
    </MuiDialog>
  );
};

export default Submit;
